/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSEOBody
 */
export interface UpdateSEOBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateSEOBody
     */
    url: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateSEOBody
     */
    tags: Array<string>;
}

/**
 * Check if a given object implements the UpdateSEOBody interface.
 */
export function instanceOfUpdateSEOBody(value: object): value is UpdateSEOBody {
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('tags' in value) || value['tags'] === undefined) return false;
    return true;
}

export function UpdateSEOBodyFromJSON(json: any): UpdateSEOBody {
    return UpdateSEOBodyFromJSONTyped(json, false);
}

export function UpdateSEOBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSEOBody {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
        'tags': json['tags'],
    };
}

export function UpdateSEOBodyToJSON(json: any): UpdateSEOBody {
    return UpdateSEOBodyToJSONTyped(json, false);
}

export function UpdateSEOBodyToJSONTyped(value?: UpdateSEOBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
        'tags': value['tags'],
    };
}

